module.exports = __webpack_public_path__ + "static/img/grayscaled37.3bd30fd9.jpg";